import { GroupPrivacyTypes } from '@app/client/common/structs/groups/social-groups';
import config from '@app/config';
import { type CreateSocialGroup } from '@app/gen';

const { podNameLimit, podNameGeneratorUrl } = config;

type FunRandomNameResponse = {
    char_length: number;
    title: string;
    words: string[];
};

export async function generateFunRandomPodName(signal?: AbortSignal): Promise<string> {
    try {
        const response = await fetch(podNameGeneratorUrl, { signal });
        const data: FunRandomNameResponse = await response.json();
        if (data.char_length <= podNameLimit) return data.title;
        return data.words.slice(0, data.words.length - 1).join(' ');
    } catch {
        return getPodDefaultName();
    }
}

export function getPodDefaultName(suffix = Date.now().toString()): CreateSocialGroup['name'] {
    return `My Yat Pod ${suffix}`;
}

export function getPodDefaultData(name: string, isPrivate?: boolean): CreateSocialGroup {
    return {
        // `owner` (Yat user id) will be automatically assigned by the backend.
        name,
        description: '',
        invite_permission: 'Admin',
        privacy: isPrivate ? GroupPrivacyTypes.Private : GroupPrivacyTypes.Public,
    };
}
